import { HttpInterceptorFn } from '@angular/common/http';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const allowedLanguages = new Set(['fr', 'en']);
  let lang = 'fr';

  if (typeof localStorage !== 'undefined') {
    const appStateRaw = localStorage.getItem('app-state');
    if (appStateRaw) {
      try {
        const appStateLang = JSON.parse(appStateRaw)?.language;
        if (appStateLang && allowedLanguages.has(appStateLang)) {
          lang = appStateLang;
        }
      } catch (error) {
        console.warn('acceptLanguageInterceptor: failed to parse app-state', error);
      }
    }
  }

  if (!allowedLanguages.has(lang) && typeof document !== 'undefined') {
    const documentLang = document.documentElement.lang;
    if (allowedLanguages.has(documentLang)) {
      lang = documentLang;
    }
  }

  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': lang,
    },
  });

  return next(cloned);
};
